// Debug Helper for Token Creation
// Run these commands in browser console to debug

// 1. Get last publish transaction data
function getLastPublishTx() {
  const data = localStorage.getItem('lastPublishTx');
  if (data) {
    const parsed = JSON.parse(data);
    console.log('Last Publish Transaction:', parsed);
    console.log('Package ID:', parsed.packageId);
    console.log('Transaction Digest:', parsed.digest);
    console.log('Created Objects:', parsed.createdObjects);
    
    // Find TreasuryCap
    const treasuryCap = parsed.createdObjects?.find(obj => 
      obj.objectType && obj.objectType.includes('TreasuryCap')
    );
    
    if (treasuryCap) {
      console.log('✅ TreasuryCap found:', treasuryCap);
      console.log('TreasuryCap ID:', treasuryCap.objectId);
    } else {
      console.log('❌ TreasuryCap not found in created objects');
      console.log('All object types:', parsed.createdObjects?.map(o => o.objectType));
    }
    
    return parsed;
  } else {
    console.log('No publish transaction data found. Try creating a token first.');
    return null;
  }
}

// 2. Get treasury cap error data
function getTreasuryCapError() {
  const data = localStorage.getItem('treasuryCapError');
  if (data) {
    const parsed = JSON.parse(data);
    console.log('Treasury Cap Error Info:', parsed);
    console.log('Transaction Digest:', parsed.digest);
    console.log('Package ID:', parsed.packageId);
    console.log('Object Changes:', parsed.objectChanges);
    
    // Analyze object changes
    if (parsed.objectChanges) {
      const created = parsed.objectChanges.filter(c => c.type === 'created');
      console.log('Created Objects Count:', created.length);
      created.forEach((obj, i) => {
        console.log(`Object ${i + 1}:`, {
          objectId: obj.objectId,
          objectType: obj.objectType,
          owner: obj.owner
        });
      });
    }
    
    return parsed;
  } else {
    console.log('No error data found.');
    return null;
  }
}

// 3. Clear debug data
function clearDebugData() {
  localStorage.removeItem('lastPublishTx');
  localStorage.removeItem('treasuryCapError');
  console.log('Debug data cleared');
}

// 4. Analyze transaction by digest
async function analyzeTransaction(digest) {
  try {
    const { SuiClient, getFullnodeUrl } = await import("@mysten/sui.js/client");
    const client = new SuiClient({ url: getFullnodeUrl("testnet") });
    
    console.log('Fetching transaction:', digest);
    const tx = await client.getTransactionBlock({
      digest,
      options: {
        showObjectChanges: true,
        showEffects: true,
        showEvents: true,
        showInput: true
      }
    });
    
    console.log('Full Transaction:', tx);
    
    // Find package
    const packageChange = tx.objectChanges?.find(c => c.type === 'published');
    if (packageChange) {
      console.log('✅ Package:', packageChange);
      console.log('Package ID:', packageChange.packageId);
    }
    
    // Find TreasuryCap
    const treasuryCap = tx.objectChanges?.find(c => 
      c.type === 'created' && 
      c.objectType && 
      c.objectType.includes('TreasuryCap')
    );
    
    if (treasuryCap) {
      console.log('✅ TreasuryCap:', treasuryCap);
      console.log('TreasuryCap ID:', treasuryCap.objectId);
    } else {
      console.log('❌ TreasuryCap not found');
      
      // List all created objects
      const created = tx.objectChanges?.filter(c => c.type === 'created');
      console.log('All created objects:', created);
    }
    
    return tx;
  } catch (error) {
    console.error('Error fetching transaction:', error);
    return null;
  }
}

// 5. Test token creation data
function createTestTokenData() {
  return {
    name: "TestToken",
    symbol: "TEST",
    description: "Test token for debugging",
    decimals: 9,
    maxSupply: "1000000000",
    feeBps: 300
  };
}

// Export functions for console use
window.debugToken = {
  getLastPublishTx,
  getTreasuryCapError,
  clearDebugData,
  analyzeTransaction,
  createTestTokenData,
  
  // Quick commands
  last: getLastPublishTx,
  error: getTreasuryCapError,
  clear: clearDebugData,
  analyze: analyzeTransaction
};

console.log(`
🔧 Token Debug Helper Loaded!
================================
Available commands:

debugToken.last()                    - Get last publish transaction data
debugToken.error()                   - Get treasury cap error details
debugToken.clear()                   - Clear all debug data
debugToken.analyze('digest')         - Analyze transaction by digest
debugToken.createTestTokenData()     - Get test token data

Quick access:
- debugToken.last()
- debugToken.error()
- debugToken.clear()

Example:
debugToken.analyze('3REH6SQmjy...')
`);
